import { Autocomplete, SelectEvent } from "@king-ict/eupisi-ui/components";
import { ChangeEvent, useMemo, useState } from "react";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";
import { CodeBook } from "@king-ict/eupisi-ui/models";
import { useGetCountiesQuery } from "../../../../queries";

interface IProps {
  label: string | undefined;
  value?: number;
  onChange: (e: ChangeEvent<SelectEvent>) => void;
  excludeCountyIds: number[];
}

export const CountySelect = ({
  label,
  value,
  onChange,
  excludeCountyIds,
}: IProps) => {
  const { data: countiesSelectData } = useGetCountiesQuery(undefined, {
    selectFromResult: (result) => {
      return {
        data: codeBookToSelectData(
          result.data?.filter((x) => !excludeCountyIds.find((c) => x.id === c))
        ),
      };
    },
  });

  return (
    <Autocomplete
      label={label}
      onChange={onChange}
      value={value}
      selectData={countiesSelectData}
    />
  );
};
